<template>
  <layout-editor-page
    :title="formTitle"
    isScrollPage
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <template v-slot:top-controls>
      <template v-if="hasCreateNew">
        <div class="control btn-mobile-full">
          <button class="btn btn-size-s" @click="showReminder" :disabled="isLoading">
            {{L10n('show-customer-reminder')}}
          </button>
        </div>
        <div class="control btn-mobile-full">
          <button class="btn btn-size-s" @click="handleSendReminder" :disabled="isLoading">
            {{L10n('send-reminder')}}
          </button>
        </div>
      </template>
    </template>
    <div class="row">
      <div class="col-8">
        <form-general
          :isNew="!hasCreateNew"
          :isLoading.sync="isLoading"
          ref="Form"
          :data="data"
          :model="formModel"
          @onAutoSave="autoSaveMiddleware"
          @change="handleFormData"
        />
      </div>
      <div class="col-4">
        <payment-log
          :paymentID="data.id"
        />
      </div>
    </div>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommandWrap"
      />
    </template>
    <dialog-reminder
      ref="dialog-reminder"
      :companyID="companyID"
      :paymentID="this.currentID"
    />
    <dialog-table
      ref="dialog-table"
      :companyID="companyID"
      :title="formTitle"
    />
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { ModelPayment, ServicePayments } from '@/services/Payments'

export default {
  name: 'EditorPayment',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'payment-log': () => import(/* webpackChunkName: 'Payments' */ './PaymentLog'),
    'dialog-reminder': () => import(/* webpackChunkName: 'Payments' */ './DialogEmailSendReminder'),
    'dialog-table': () => import(/* webpackChunkName: 'Payments' */ './DialogRemainderTable'),
    'form-general': () => import(/* webpackChunkName: 'Payments' */ './FormGeneral')
  },
  computed: {
    formTitle () {
      return this.formData.invoiceNumber
    },
    isAvailableToSave () {
      return this.hasCreateNew
    },
    apiAutoSave () {
      return `Payments/Patch/${this.currentID}`
    },
    companyID () {
      return this.formData.companyID
    }
  },
  methods: {
    formModel () {
      return new ModelPayment()
    },
    async setCommandWrap (command) {
      const data = this.$refs.Form.getData()

      if (command === 'save' && !this.hasCreateNew) {
        const result = await ServicePayments
          .checkExistPayment({ invoiceID: data.invoiceID, invoiceNumber: data.invoiceNumber, customerPO: data.customerPO })
        if (result.isExist) {
          return this.$notify.error({
            title: 'Error',
            message: this.L10n('payment-already-exist'),
            position: 'bottom-right'
          })
        }
      }
      this.setCommand(command)
    },
    async handleSendReminder () {
      this.isLoading = true
      try {
        this.$refs['dialog-reminder'].show()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async showReminder () {
      this.$refs['dialog-table'].show()
    },
    async autoSaveMiddleware (props) {
      const { field, value, label } = props
      const id = this.data.id
      this.mixAutoSave(props)
        .then(({ e, config }) => {
          if (!e) {
            ServicePayments
              .updateNotification({ field, value, id, labelSelect: label })
              .then(() => {
                this.$bus.$emit('on-update-log')
              })
          }
        })
    }
  }
}
</script>
